export const boot = (options = {}) => {
  if (typeof window !== 'undefined') {
    window?.Intercom?.('boot', {
      api_base: 'https://api-iam.intercom.io',
      app_id: process.env.INTERCOM_APP_ID,
      custom_launcher_selector: '#intercom-launcher',
      hide_default_launcher: true,
      ...options,
    });
  }
};

export const update = (options = {}) => {
  if (typeof window !== 'undefined') {
    window?.Intercom?.('update', {
      ...options,
    });
  }
};

export const show = () => {
  if (typeof window !== 'undefined') {
    window?.Intercom?.('show');
  }
};

export const startSurvey = (id: number) => {
  if (typeof window !== 'undefined') {
    window?.Intercom?.('startSurvey', id);
  }
};

export const showNewMessage = (message: string) => {
  if (typeof window !== 'undefined') {
    window?.Intercom?.('showNewMessage', message);
  }
};

export const showArticle = (articleId: number) => {
  if (typeof window !== 'undefined') {
    window?.Intercom?.('showArticle', articleId);
  }
};

export const shutdown = () => {
  if (typeof window !== 'undefined') {
    window?.Intercom?.('shutdown');
  }
};
